@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.config
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.web.dto.currency.CurrencyDto

class CurrencyIncentiveConfigDto (
    val id: KmmLong?,
    val currencyId: Int,
    val orderingIncentiveConfig: OrderingIncentiveConfigDto,
    val timeoutIncentiveConfig: TimeoutIncentiveConfigDto
)
class ExtendedCurrencyIncentiveConfigDto (
    val currency: CurrencyDto,
    val currencyIncentiveConfig: CurrencyIncentiveConfigDto
)

